import { render } from "./TheCategories.vue?vue&type=template&id=090ed1da&scoped=true"
import script from "./TheCategories.vue?vue&type=script&lang=js"
export * from "./TheCategories.vue?vue&type=script&lang=js"

import "./TheCategories.vue?vue&type=style&index=0&id=090ed1da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090ed1da"]])

export default __exports__